import { ReactError } from 'consts/ReactError';
import { ApiError } from 'requests/RequestBase';

// APIGWのエラーコードと画面で表示するエラーメッセージのenum
export const ApiErrorCode = {
	E1012: { code: 'E1012', message: ReactError.E0003 }, // パスワード誤り
	E1045: { code: 'E1045', message: ReactError.E0003 }, // 存在しないGID
	E1048: { code: 'E1048', message: ReactError.E0002 }, // アカウントロック
	E1104: { code: 'E1104', message: ReactError.E0013 }, // PayPalオーソリ実行不可
	E1124: { code: 'E1124', message: ReactError.E0013 }, // クレジットカード決済エラー
	E1157: { code: 'E1157', message: ReactError.E0010 }, // ワンタイムパスワード5回以上失敗
	E1180: { code: 'E1180', message: ReactError.E0012 }, // カード登録上限
} as const;

export const findErrorMessageByApiError = (apiError: ApiError) => {
	const apiErrorCode = Object.values(ApiErrorCode).find((p) => p.code === apiError.error_code);
	return apiErrorCode ? apiErrorCode.message : apiError?.message || ReactError.E9999;
};

// カードの決済・オーソリエラーかどうか
export const isCardError = (apiError: ApiError) => {
	return ApiErrorCode.E1104.code === apiError.error_code || ApiErrorCode.E1124.code === apiError.error_code;
};
